import {JobInsightsStatus, JobMetricsStatus, JobStatus} from "@/core/models/enums/job.enums";

export class VoiceJob {

    constructor(
        public jobId: string,
        public status: JobStatus,
        public metricsStatus: JobMetricsStatus,
        public createdAt: string,
        public startedAt: string,
        public durationSec: number,
        public result?: any,
        public error?: string,
        public filename?: string,
        public final_conversation_title?: string,
        public audioUrl?: string,
        public videoUrl?: string,
        public finishedAt?: string,
        public insightsStatus?: JobInsightsStatus,
        public insightsError?: string,
        public insightsGeneratedAt?: string,
    ) {}

    isFinished(): boolean {
        return this.status === JobStatus.FINISHED;
    }

    isProcessing(): boolean {
        return this.status === JobStatus.PROCESSING;
    }

    isFailed(): boolean {
        return this.status === JobStatus.FAILED;
    }

    isInsightsFinished(): boolean {
        return this.insightsStatus === JobInsightsStatus.FINISHED;
    }

    isInsightsProcessing(): boolean {
        return this.insightsStatus === JobInsightsStatus.PROCESSING;
    }

    isInsightsFailed(): boolean {
        return this.insightsStatus === JobInsightsStatus.FAILED;
    }
}